export default __webpack_public_path__ + "static/banner-api-415d527c98df32dc2f99b597d5e42d72.png";